import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import { AgGridReact } from "ag-grid-react";
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { ModuleRegistry, AllCommunityModule, themeBalham } from 'ag-grid-community';
import { entrylayoutclose } from '../modules/formstore';

// 必要なモジュールを登録
ModuleRegistry.registerModules([
    AllEnterpriseModule,
    AllCommunityModule
]);


const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});
const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

//-------------------------------------------------------
//  基本情報項目設定
//
//  onAppry:レイアウト適用 callback
//  columninfo:全カラム情報
//  textfields:textfields
//-------------------------------------------------------
export default function EntryLayout(props) {

    const entrylayoutopen = useSelector(state => state.form.entrylayoutopen);
    const entrylayouttype = useSelector(state => state.form.entrylayouttype);
    const [show, setshow] = useState(false);
    const [leftApi, setLeftApi] = useState(null);
    const [rightApi, setRightApi] = useState(null);
    const [leftRowData, setleftRowData] = useState([]);
    const [rightRowData, setrightRowData] = useState([]);
    const leftColumns = [
        { headerName: "基本情報項目", field: 'colnm', rowDrag: true, flex:1, filter:true },
        { field: 'colId', hide: true },
        {  field: 'type', hide: true }
    ];
    const rightColumns = [
        { headerName: "非表示項目", field: 'colnm', rowDrag: true, flex: 1, filter: true},
        { field: 'colId', hide: true },
        { field: 'type', hide: true }
    ];
    const getRowNodeId = data => data.colId
    const dispatch = useDispatch();
    const leftApiRef = useRef(null);
    const rightApiRef = useRef(null);


    useEffect(() => {
        if (!entrylayoutopen)
            return;
        var left = [];
        var right = [];
        let items = props.textfields.filter(e => e.type === entrylayouttype);
        for (let i = 0; i < items.length; i++) {
            let column = items[i];
            let item = {
                colId: column.columnid,
                colnm: column.columnnm,
                type: column.datatype,
            }
            left.push(item);
        }
        let target = props.columninfo.filter(e => e.type === entrylayouttype && e.hidden !== "2");
        for (let i = 0; i < target.length; i++) {
            let column = target[i];
            if (column === undefined) continue;
            let item = {
                colId: column.columnid,
                colnm: column.columnnm,
                type: column.datatype,
            }

            if (props.textfields.find(e => e.columnid === column.columnid)) {
        //        left.push(item);
            } else {
                right.push(item);
            }
        }
        setleftRowData(left);
        setrightRowData(right);
        setshow(true);

    }, [entrylayoutopen])

     useEffect(() => {
        try {
            if (rightApi && leftApi) {
                addGridDropZone('Right', rightApi);
                addGridDropZone('Left', leftApi);
            }
        } catch (error) {
            console.log(error);
        }
     })

    function onClose() {
        dispatch(entrylayoutclose());
        setshow(false);
    }

    const addGridDropZone = (side, api) => {
        // 移動先
        const dropApi = side === 'Left' ? rightApi : leftApi;
        // 移動元
        const srcApi = side !== 'Left' ? rightApi : leftApi;
        const dropZoneParams = dropApi.getRowDropZoneParams({
            onDragStop: function (params) {
                // 移動データを取得
                const movedata = params.nodes.map(n => n.data);
                // 挿入位置（overIndex）を取得
                const insertIndex = params.overIndex ?? 0;
                
                // 元のデータから移動したデータを削除
                srcApi.applyTransaction({
                    remove: params.nodes.map(function (node) { return node.data; })
                });

                // side:元カラム
                if (side === 'Left') {
                    // 右カラムにデータを挿入
                    setrightRowData(prev => {
                        const newArr = [...prev];
                        newArr.splice(insertIndex, 0, ...movedata);
                        return newArr;
                    });
                } else {
                    // 左カラムにデータを挿入
                    setleftRowData(prev => {
                        const newArr = [...prev];
                        newArr.splice(insertIndex, 0, ...movedata);
                        return newArr;
                    });
                }
            }
        });
        api.addRowDropZone(dropZoneParams);
    };

    function onGridReady(params, side) {
        if (side === 0) {
            setLeftApi(params.api);
            leftApiRef.current = params.api;
        }
        if (side === 1) {
            setRightApi(params.api);
            rightApiRef.current = params.api;

        }
    };

    //適用
    function onAppry() {
        leftApi.stopEditing();
        let newcol = [];
        leftApi.forEachNode(function (node) {
           newcol.push(node.data.colId);
        });
        props.onAppry(newcol, entrylayouttype);
        onClose();
    }

    const DialogTitle = withStyles(styles)((props) => {
        const { children, classes, onClose, ...other } = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <Icon>close</Icon>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    function getContextMenuItems(params) {
        var result = [];
        result.push(
            {
                name: '全選択',
                action: function () {
                    params.api.selectAllFiltered();
                },
            });
        result.push(
            {
                name: '選択解除',
                action: function () {
                    params.api.deselectAll();
                },
            });
        result.push(
            {
                name: '選択行反転',
                action: function () {
                    params.api.forEachNode(node => node.isSelected() ? node.setSelected(false) : node.setSelected(true));
                },
            });
        return result;
    };
    return (
        < div style={{ height:1000}} >
            <Dialog open={show} fullWidth={false} maxWidth={ 'md'}>
                <DialogTitle id="customized-dialog-title" onClose={onClose}>
                基本情報項目設定
            </DialogTitle>

            <DialogContent dividers>
                <div style={{ height: 500, width: 280, display: 'inline-block' }} >
                    <div className="ag-theme-balham" style={{ height: 480, width: 250 }}>
                    <AgGridReact
                        theme={themeBalham}
                        columnMenu="legacy"
                        getRowNodeId={getRowNodeId}
                        onGridReady={(params) => onGridReady(params, 0)}
                        rowData={leftRowData}
                        columnDefs={leftColumns}
                        rowDragManaged={true}
                        animateRows={true}
                        rowSelection={"multiple"}
                        rowDragMultiRow={true}
                        suppressDragLeaveHidesColumns={true}
                        rowMultiSelectWithClick={true}
                        suppressMoveWhenRowDragging={true}
                        getContextMenuItems={getContextMenuItems}
                    >
                    </AgGridReact>
                </div>
                </div>
                <div style={{ height: 500, width: 280, display: 'inline-block' }} >
                    <div className="ag-theme-balham" style={{ height: 480, width: 250  }}>
                    <AgGridReact
                        theme={themeBalham}
                        columnMenu="legacy"
                        getRowNodeId={getRowNodeId}
                        onGridReady={(params) => onGridReady(params,1)}
                        modules={[AllCommunityModule, AllEnterpriseModule]}
                        rowData={rightRowData}
                        columnDefs={rightColumns}
                        rowDragManaged={true}
                        animateRows={true}
                        rowSelection={"multiple"}
                        rowDragMultiRow={true}
                        suppressDragLeaveHidesColumns={true}
                        rowMultiSelectWithClick={true}
                        suppressMoveWhenRowDragging={true}
                        getContextMenuItems={getContextMenuItems}
                    >
                    </AgGridReact>
                </div>
                </div>
            </DialogContent>

            <DialogActions>
                    <Button autoFocus onClick={onAppry} color="primary">
                    適用
                </Button>
            </DialogActions>
      </Dialog>
    </div >
    );

}